import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
import footerlogo from '../img/footer-logo.jpg'
  
export default class Footer extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
        

          
        }
    }

    



    render() {
       
        return(
            <div>
            

            <footer>
	        <div class="container">
	 
	             <div class="row">
	            	<div class="col-lg-4">
	 		            <img src={footerlogo} class="img-fluid" />
                        <p class="mt-5 text-center">2020 © copyright <br/> All rights reserved.</p>

                        <div class="social-media">
			                <ul class="list-inline footer-social-media">
					            <li class="list-inline-item"><a href="https://www.facebook.com/globalstudiesinstitute/" target="_blank"><i class="fa fa-facebook-f"></i></a></li>
					            <li class="list-inline-item"><a href="https://twitter.com/gsiqatar" target="_blank"><i class="fa fa-twitter"></i></a></li>
					            <li class="list-inline-item"><a href="https://instagram.com/gsi.qatar?igshid=om2vekoz3rrr" target="_blank"><i class="fa fa-instagram"></i></a></li>
					            <li  class="list-inline-item"><a href="https://www.linkedin.com/company/global-studies-institute-qatar"  target="_blank"><i class="fa fa-linkedin"></i></a></li>
			                </ul>
		                </div>

	 	            </div>

	 	            <div class="col-lg-4 col-5">
	 		        <h5 class="color-1">Navigation</h5>
	 		            <ul class="list-unstyled">
                            <Link to="/aboutus"><li>About</li></Link>
                            <Link to="/liveclassroomtechnology"><li>Technology</li></Link>
                            <Link to="/academics"><li>Academics</li></Link>
                            <Link to="/aspirecampus"><li>Aspire Campus</li></Link>
                            <Link to="/partner_universities"><li>Partner Universities</li></Link>
                            <Link to="/contactus"><li>Contact Us</li></Link>
			            </ul>   
	 	            </div>



<div class="col-lg-4 col-7">
	<h5 class="color-1">Contact Us</h5>

 		<ul class="list-unstyled">
           <li>	Aspire Academy, Aspire Zone</li> 
		  <li>	Al Henaizibia Street, Al Waab,<br/> Doha, Qatar</li><br/>
		  <li> <i class="fa fa-envelope "></i> info@gsi-qatar.org</li>
		  <li> <i class="fa fa-phone "></i> +974 3007 6005</li>
		</ul>

</div>
	 </div>		
	</div>
</footer>
          

            </div>
            
        )
    }
}